import { render, staticRenderFns } from "./MedaliSertifikatIcon.vue?vue&type=template&id=1522451a"
import script from "./MedaliSertifikatIcon.vue?vue&type=script&lang=js"
export * from "./MedaliSertifikatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports